import { render, staticRenderFns } from "./Restriction.vue?vue&type=template&id=7d6d163a"
import script from "./Restriction.vue?vue&type=script&lang=ts"
export * from "./Restriction.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports